import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Container, Nav } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";

import Header_Company from "../../Components/Header_Company";
import Header_Manager from "../../Components/Header_Manager";
import Header_Admin from "../../Components/Header_Admin";
import CurrentDayRecord from "../../Components/CompanyDetails/CurrentDayRecord";
import AllRecord from "../../Components/CompanyDetails/AllRecord";
import "./Company.css";

const Company_Dashboard = () => {
  const [activeTab, setActiveTab] = useState("currentDay");
  const [userRole, setUserRole] = useState("");
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    if (!storedUserData) {
      Swal.fire("Error", "Your session has expired. Please sign in again.", "error");
      return;
    }

    const user = JSON.parse(storedUserData);
    setUserRole(user.userRole || "");
    setCompanyName(user.selectedCompanyName || user.companyName || user.name || "");
  }, []);

  const renderHeader = () => {
    if (userRole === "Manager") return <Header_Manager />;
    if (userRole === "Admin") return <Header_Admin />;
    return <Header_Company />;
  };

  return (
    <div className="co-page">
      {renderHeader()}

      <Container fluid="xl">
        <div className="co-hero d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2">
          <div>
            <h2>
              <i className="bi bi-speedometer2 me-2" />
              Company Dashboard
            </h2>
            <p>
              {companyName
                ? `Overview for ${companyName}`
                : "View payment summary and performance metrics"}
            </p>
          </div>
          {userRole === "Manager" && companyName && (
            <span className="badge text-bg-info align-self-start align-self-md-center px-3 py-2">
              <i className="bi bi-eye me-1" />
              Viewing as Manager
            </span>
          )}
        </div>

        <Nav variant="pills" className="co-step-nav gap-2 mb-3 flex-nowrap">
          <Nav.Item>
            <Nav.Link
              active={activeTab === "currentDay"}
              onClick={() => setActiveTab("currentDay")}
            >
              <i className="bi bi-calendar-day me-1" />
              Current Day
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === "allRecord"}
              onClick={() => setActiveTab("allRecord")}
            >
              <i className="bi bi-calendar3 me-1" />
              All Records
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <div className="tab-content">
          {activeTab === "currentDay" && <CurrentDayRecord />}
          {activeTab === "allRecord" && <AllRecord />}
        </div>
      </Container>
    </div>
  );
};

export default Company_Dashboard;
